<template>
  <div class="noticesearch">
    <form action="/">
      <van-search
        v-model="value"
        show-action
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @cancel="onCancel"
        background="#fff"
      />
    </form>
  <van-cell v-for="(item,index) in list" :key="index" :title="item.productName" @click="checked(item)"/>
  </div>
</template>
<script>
import {getqueryByName} from '../../api/notice'
export default {
  data() {
    return {
        value:'',
        list: [],
      loading: false,
      finished: false,
    };
  },
  methods: {
    onSearch(val) {
      let data={
          productName:val,
          // enabled:true
      }
      getqueryByName(data).then(res=>{
          console.log(res)
          this.list=res
      })
    },
    onCancel() {
      this.$router.go(-1)
    },
    checked(item){
        console.log(item)
        let {id,companyId,company,productName}=item
        let val=JSON.stringify({id,companyId,company,productName})
        console.log(val)
        sessionStorage.setItem('proditem',val)
        this.$router.go(-1)
    }
  },
  mounted(){
    this.onSearch()
  }
};
</script>
<style lang="less" scoped>
.noticesearch {
  width: 100%;
  background: #fff;
}
</style>